import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { STRINGS_LOAD_MORE } from "../../../data/strings/Strings";
import { HeaderView } from "../../component/HeaderView";
import { TransactionsViewModel } from "./TransactionsViewModel";
import { LoadingView } from "../../component/LoadingView";
import { EmptyView } from "../../component/EmptyView";
import { provideGetAllTransactionsUseCase } from "../../di/UseCasesModule";
import { CustomTextView } from "../../component/CustomTextView";
import {
  COLOR_BLACK,
  COLOR_GREEN,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
  GRADIENT_MAIN,
} from "../../../data/colors/Colors";
import moment from "moment";
import { CheckBox } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";

export function TransactionsView() {
  const viewModel = TransactionsViewModel(provideGetAllTransactionsUseCase());

  return (
    <Stack spacing={2}>
      <HeaderView
        title={"Transactions"}
        isLayoutFullWidthInSmallerScreens={false}
        layout={<></>}
      />
      <Container maxWidth={false}>
        {viewModel.isLoading && viewModel.transactions?.length === 0 ? (
          <LoadingView />
        ) : (
          <>
            <Grid container spacing={2} pt={0} pb={2}>
              {viewModel.transactions && viewModel.transactions.length > 0 ? (
                <TableContainer
                  component={Paper}
                  sx={{
                    borderRadius: 8,
                    background: "transparent",
                    border: "1px solid lightGray",
                    boxShadow: 0,
                  }}
                >
                  <Table aria-label="simple table">
                    <TableHead sx={{ background: COLOR_MAIN }}>
                      <TableRow>
                        <TableCell>
                          <CustomTextView
                            text="Invoice Id"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                          />
                        </TableCell>
                        <TableCell>
                          <CustomTextView
                            text="Customer"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CustomTextView
                            text="Transaction Status"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                            textAlign="center"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CustomTextView
                            text="Transaction Display Value"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                            textAlign="center"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CustomTextView
                            text="Delivery Price"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                            textAlign="center"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CustomTextView
                            text="Created"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                            textAlign="center"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CustomTextView
                            text="Quantity"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                            textAlign="center"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <CustomTextView
                            text="Product Name"
                            fontWeight="bold"
                            fontSize={14}
                            textColor="white"
                            textAlign="center"
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {viewModel.transactions.map((transaction, index) => (
                        <TableRow
                          key={transaction._id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>
                            <CustomTextView
                              text={transaction.invoiceId}
                              fontSize={14}
                            />
                          </TableCell>
                          <TableCell>
                            {transaction.customer && (
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={1}
                              >
                                <Link
                                  to={
                                    ROUTE_ENDPOINTS.HOME_CUSTOMERS +
                                    "/" +
                                    transaction.customer._id
                                  }
                                  target="_blank"
                                >
                                  <CustomTextView
                                    text={transaction.customer.user?.email}
                                    fontSize={14}
                                    fontWeight="bold"
                                  />
                                </Link>
                              </Stack>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {transaction.invoiceStatus == "Paid" && (
                              <CheckBox sx={{ color: COLOR_GREEN }} />
                            )}
                            {transaction.invoiceStatus != "Paid" && (
                              <CheckBox sx={{ color: "red" }} />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <CustomTextView
                              text={transaction.invoiceDisplayValue}
                              fontSize={14}
                              textAlign="center"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <CustomTextView
                              text={`${transaction.deliveryPrice.toFixed(2)} QAR`}
                              fontSize={14}
                              textAlign="center"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <CustomTextView
                              text={moment(
                                new Date(transaction.createdAt)
                              ).fromNow()}
                              fontSize={14}
                              textAlign="center"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <CustomTextView
                              text={`${transaction.quantity}`}
                              fontSize={14}
                              textAlign="center"
                            />
                          </TableCell>
                          <TableCell align="center">
                            {transaction.product ? (
                              <Link
                                to={
                                  ROUTE_ENDPOINTS.HOME_PRODUCTS +
                                  "/" +
                                  transaction.product._id
                                }
                                target="_blank"
                              >
                                <CustomTextView
                                  text={transaction.product.name}
                                  fontSize={14}
                                  textAlign="center"
                                />
                              </Link>
                            ) : (
                              <CustomTextView
                                text="REMOVED"
                                textColor="red"
                                textAlign="center"
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <EmptyView />
              )}
              <Grid
                alignItems={"center"}
                justifyContent={"center"}
                display={"flex"}
                size={12}
              >
                {viewModel.isLoading ? (
                  <LoadingView minHeight="5vh" />
                ) : (
                  <>
                    {viewModel.showLoadMoreButton && (
                      <Button
                        variant="outlined"
                        sx={{
                          borderRadius: 22,
                          textTransform: "none",
                          borderColor: COLOR_BLACK,
                          "&:hover": {
                            borderColor: COLOR_BLACK,
                            background: COLOR_LIGHT_GRAY,
                          },
                        }}
                        onClick={viewModel.getTransactions}
                      >
                        <CustomTextView
                          text={STRINGS_LOAD_MORE}
                          variant="h6"
                          fontWeight="bold"
                        />
                      </Button>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </Stack>
  );
}
